import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAdPrice, GetAdPriceRequest } from "./adPrice.api";
import { AdPriceActions } from "./adPrice.slice";

export const GetAdPriceThunk = createAsyncThunk(
  "adPrice/GetAdPrice",
  async (request: GetAdPriceRequest, { rejectWithValue, dispatch }) => {
    dispatch(AdPriceActions.setAdPriceLoading(true));
    const { response, error } = await getAdPrice(request);
    dispatch(AdPriceActions.setAdPriceLoading(false));
    if (error) {
      dispatch(AdPriceActions.setAdPriceLoading(false));
      return rejectWithValue(error);
    }
    return response;
  }
);
